import { BreadcrumbItem } from '@app/models/app.model';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export interface AppState {
  breadcrumbs: BreadcrumbItem[];
}

export const AppStore = signalStore(
  { providedIn: 'root' },
  withState<AppState>({
    breadcrumbs: [],
  }),
  withMethods((state) => {
    return {
      updateBreadcrumbs: (breadcrumbs: BreadcrumbItem[]) =>
        patchState(state, { breadcrumbs }),
    };
  })
);
